import {
    SET_ERROR,

    CORE_AUTH_VERIFY_FAILURE,
    CORE_AUTH_VERIFY_SUCCESS,

    CORE_FIND_DISPLAY_INFO_SUCCESS,
    CORE_FIND_DISPLAY_INFO_FAILURE,

} from '../types'


const initialStateCallAPI = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
}
    , initialStateArray = []


export default {
    errorList: (state = initialStateArray, action) => {
        switch (action.type) {
            case SET_ERROR:
                let newError = []
                if (action && Array.isArray(action.error)) {
                    newError = action.error
                }
                return newError
            case CORE_AUTH_VERIFY_FAILURE:
            case CORE_FIND_DISPLAY_INFO_FAILURE:
                if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { errorList, code, message, statusText, statusCode } = action.payload
                    const { url } = action
                    let newError = []
                    if (Array.isArray(errorList)) {
                        newError = errorList.map(e => e)
                    }

                    newError.push({ code, message, isShow: false, statusText, statusCode, url })

                    return newError
                } return state
            case CORE_AUTH_VERIFY_SUCCESS:
            case CORE_FIND_DISPLAY_INFO_SUCCESS:
                if (action && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    const { errors, result } = action.payload
                    if (!result && Array.isArray(errors)) {
                        let errorList = []
                        errors.forEach(e => {
                            const { code, message } = e
                            errorList.push({ code, message, statusText: message, statusCode: code, isShow: false })
                        });
                        return errorList
                    }
                }
                return state
            default:
                return state
        }
    },
    reducerCallAPI: (state = initialStateCallAPI, action) => {
        switch (action.type) {

            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerCallAPI.js